import { DocumentationEntryAuthor } from 'app/_models/model/documentationEntryAuthor';
import { IEntryForShow } from 'projects/journal/src/_interface/ientry-for-show';

export const selectAllAuthors = (entries: IEntryForShow[]): DocumentationEntryAuthor[] => {
	const authorsMap = new Map<string, DocumentationEntryAuthor>();
	entries.forEach(entry => {
		const author = entry.author;
		if (author?.authorId && !authorsMap.has(author.authorId)) {
			authorsMap.set(author.authorId, author);
		}});
	return Array.from(authorsMap.values());
};
